module.exports = __webpack_public_path__ + "components/MapControl/svg/Informacja turystyczna.svg?31fe0031";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Informacja turystyczna.svg
// module id = 1932
// module chunks = 0